<template>
  <div class="finance-info" v-if="canLoad">
    <div class="title-data">
      <span>{{ $t('lang.k_132001') }}</span>
      <div class="detail" v-if="buttonList.includes('details')" @click="goAccountDetail">
        {{ $t('lang.k_132002') }}
      </div>
      <div class="detail" @click="openEarlyWarning">{{ $t('lang.k_132003') }}</div>
    </div>
    <div class="version-info">
      <version-info ref="versionInfo"></version-info>
    </div>
    <div class="statistical-line">
      <div class="serach-line">
        <span>{{ $t('lang.k_132004') }}</span>
        <vh-tooltip effect="dark" placement="right" v-tooltipMove>
          <div slot="content" v-if="versionType">
            1.{{ versionType == 1 ? $t('lang.k_132005') : $t('lang.k_132006') }}
            <br />
            {{ $t('lang.k_132007') }}
          </div>
          <div slot="content" v-else>
            {{ $t('lang.k_132008') }}
            <br />
            {{ $t('lang.k_132009') }}
            <br />
            {{ $t('lang.k_132010') }}
          </div>
          <i class="iconfont-v3 saasicon_help_m"></i>
        </vh-tooltip>
        <div class="search-data">
          <vh-date-picker
            round
            v-model="lineSearchDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            @change="getLineList"
            :range-separator="$t('lang.k_132011')"
            :start-placeholder="$t('lang.k_132012')"
            :end-placeholder="$t('lang.k_132013')"
            :picker-options="pickerOptions"
            prefix-icon="iconfont-v3 saasicon_date"
            style="width: 240px"
          />
          <vh-select
            round
            filterable
            v-model="lineType"
            style="width: 160px; marginleft: 15px"
            @change="getSearchLineList"
            v-if="type"
          >
            <vh-option
              v-for="(opt, optIndex) in versionList"
              :key="optIndex"
              :label="opt.label"
              :value="opt.value"
            />
          </vh-select>
          <div class="export-data">
            <vh-button plain round size="medium" @click="exportCenterData">
              {{ $t('lang.k_132014') }}
            </vh-button>
          </div>
        </div>
        <!-- <search-area
            ref="searchLineLayout"
            :isDate="isLineDate"
            :searchAreaLayout="searchLineLayout"
            @onExportData="exportCenterData()"
            @onSearchFun="getLineList()"
          >
          </search-area> -->
        <lint-charts :lineDataList="lintData" :type="parseInt(versionType)"></lint-charts>
      </div>
    </div>
    <div class="statistical-line">
      <div class="serach-line">
        <span>{{ $t('lang.k_132015') }}</span>
        <vh-tooltip effect="dark" placement="right" v-tooltipMove>
          <div slot="content" v-if="versionType == 1">
            {{ $t('lang.k_132016') }}
            <br />
            {{ $t('lang.k_132017') }}
          </div>
          <div slot="content" v-if="versionType == 2">
            {{ $t('lang.k_132018') }}
            <br />
            {{ $t('lang.k_132019') }}
            <br />
            {{ $t('lang.k_132010') }}
            <br />
            {{ $t('lang.k_132020') }}
          </div>
          <div slot="content" v-else>
            {{ $t('lang.k_132021') }}
            <br />
            {{ $t('lang.k_132009') }}
            <br />
            {{ $t('lang.k_132010') }}
          </div>
          <i class="iconfont-v3 saasicon_help_m"></i>
        </vh-tooltip>
        <div class="search-data">
          <vh-date-picker
            round
            v-model="accountSearchDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            prefix-icon="iconfont-v3 saasicon_date"
            @change="getSearchList"
            :range-separator="$t('lang.k_132011')"
            :start-placeholder="$t('lang.k_132012')"
            :end-placeholder="$t('lang.k_132013')"
            :picker-options="pickerOptionsTwo"
            style="width: 240px"
          />
          <vh-input
            round
            v-model="subject"
            :placeholder="$t('lang.k_132022')"
            class="search-tag"
            style="width: 220px; marginleft: 15px"
            @keyup.enter.native="getSearchList"
            maxlength="50"
            @clear="getSearchList"
            :clearable="true"
          >
            <i
              slot="prefix"
              class="vh-icon-search vh-input__icon"
              @click="getSearchList"
              style="cursor: pointer; line-height: 36px"
            ></i>
          </vh-input>
          <vh-select
            round
            filterable
            v-model="accountType"
            style="width: 160px; marginleft: 15px"
            @change="getTypeList"
            v-if="type"
          >
            <vh-option
              v-for="(opt, optIndex) in versionList"
              :key="optIndex"
              :label="opt.label"
              :value="opt.value"
            />
          </vh-select>
          <vh-select
            round
            filterable
            v-model="trendType"
            style="width: 160px; marginleft: 15px"
            @change="getTypeList"
            v-if="showSmsModule"
          >
            <vh-option
              v-for="(opt, optIndex) in trendTypeOptions"
              :key="optIndex"
              :label="opt.label"
              :value="opt.value"
            />
          </vh-select>
          <div class="export-data">
            <vh-button plain round size="medium" @click="exportAccount">
              {{ $t('lang.k_132014') }}
            </vh-button>
          </div>
        </div>
        <div
          :class="[
            'content-grid',
            showSmsModule && smsInfo && smsInfo.sms >= 0 ? 'include_sms' : ''
          ]"
          v-if="!versionType"
        >
          <div class="grid-item">
            <div class="grid-content">
              <p>{{ $t('lang.k_132023') }}</p>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">{{ $t('lang.k_132024') }}</div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h1 class="custom-font-barlow">{{ trendData.webinar_num || 0 }}</h1>
            </div>
          </div>
          <div class="grid-item">
            <div class="grid-content">
              <p>{{ $t('lang.k_132025') }}</p>
              <h1 class="custom-font-barlow">{{ trendData.max_uv || 0 }}</h1>
            </div>
          </div>
          <div class="grid-item" v-if="showSmsModule">
            <div class="grid-content">
              <p>{{ $t('lang.k_132026') }}</p>
              <h1 class="custom-font-barlow">{{ (smsInfo && smsInfo.sms) || 0 }}</h1>
            </div>
          </div>
        </div>
        <div :class="['content-grid', showSmsModule ? 'include_sms' : '']" v-else>
          <div class="content-item">
            <div class="grid-content">
              <p>{{ $t('lang.k_132027') }}</p>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">
                  {{ $t('lang.k_132028') }}{{ versionType == 1 ? $t('lang.k_132029') : ''
                  }}{{ $t('lang.k_132030') }}
                </div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h1 class="custom-font-barlow">{{ trendData.webinar_num || 0 }}</h1>
            </div>
          </div>
          <div class="content-item">
            <div class="grid-content">
              <p>{{ versionType == 1 ? $t('lang.k_132031') : $t('lang.k_132032') }}</p>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">
                  {{ versionType == 1 ? $t('lang.k_132033') : $t('lang.k_132034') }}
                </div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h1 class="custom-font-barlow">
                {{ versionType == 1 ? trendData.total_flow || 0 : trendData.total_duration || 0 }}
              </h1>
            </div>
          </div>
          <div class="content-item">
            <div class="grid-content">
              <p>{{ versionType == 1 ? $t('lang.k_132035') : $t('lang.k_132036') }}</p>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">
                  {{ versionType == 1 ? $t('lang.k_132037') : $t('lang.k_132038') }}
                </div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h1 class="custom-font-barlow">
                {{ versionType == 1 ? trendData.live_flow || 0 : trendData.live_duration || 0 }}
              </h1>
            </div>
          </div>
          <div class="content-item">
            <div class="grid-content">
              <p>{{ versionType == 1 ? $t('lang.k_132039') : $t('lang.k_132040') }}</p>
              <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                <div slot="content">
                  {{ versionType == 1 ? $t('lang.k_132041') : $t('lang.k_132042') }}
                </div>
                <i class="iconfont-v3 saasicon_help_m"></i>
              </vh-tooltip>
              <h1 class="custom-font-barlow">
                {{ versionType == 1 ? trendData.vod_flow || 0 : trendData.vod_duration || 0 }}
              </h1>
            </div>
          </div>
          <div class="content-item" v-if="showSmsModule">
            <div class="grid-content">
              <p>{{ $t('lang.k_132026') }}</p>
              <h1 class="custom-font-barlow">{{ (smsInfo && smsInfo.sms) || 0 }}</h1>
            </div>
          </div>
        </div>
        <div class="list_info">
          <table-list
            ref="accountTableList"
            :manageTableData="trendType == 'sms' ? tableCmsList : tableList"
            :tabelColumnLabel="trendType == 'sms' ? tableCmsColumn : tableColumn"
            :isCheckout="false"
            :isHandle="false"
            :totalNum="trendType == 'sms' ? cmsTotalNum : totalNum"
            @getTableList="getAccountList"
          ></table-list>
          <noData
            :nullType="'nullData'"
            v-if="trendType == 'sms' ? !cmsTotalNum : !totalNum"
            :text="$t('lang.k_132043')"
          ></noData>
        </div>
      </div>
    </div>
    <!-- 下载弹窗 -->
    <vh-dialog
      :title="$t('lang.k_132003')"
      :visible.sync="earlyWarningVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="720px"
      custom-class="earlyWarningSet"
    >
      <!-- <div class="title">为了不影响您的正常业务，请根据实际情况设置预警提醒。</div> -->

      <div class="formItem">
        <div class="label">{{ $t('lang.k_132044') }}</div>
        <div class="vals swtich">
          <vh-switch
            class="swtich"
            v-model="warning.alertSwitch"
            active-color="#FB3A32"
            inactive-color="#CECECE"
            :active-text="alertSwitchDesc"
          ></vh-switch>
        </div>
      </div>
      <div class="formItem">
        <div class="label">{{ resourceTypes[warning.type] }}&nbsp;{{ $t('lang.k_132045') }}</div>
        <div class="vals">
          <div class="inputs">
            <vh-input
              class="setInput"
              :placeholder="$t('lang.k_132046')"
              v-model.trim="warning.value"
              :disabled="!warning.alertSwitch"
              v-clearEmoij
            >
              <template slot="append" v-if="resourceTypesItem[warning.type]">
                {{ resourceTypesItem[warning.type] }}
              </template>
            </vh-input>

            <vh-input
              class="setInput"
              :placeholder="$t('lang.k_132047')"
              v-model.trim="warning.phone"
              :disabled="!warning.alertSwitch"
              v-clearEmoij
            ></vh-input>
            <vh-input
              class="setInput"
              :placeholder="$t('lang.k_132048')"
              v-model.trim="warning.email"
              :disabled="!warning.alertSwitch"
              v-clearEmoij
            ></vh-input>
          </div>
          <div class="tip">
            {{ $t('lang.k_132049')
            }}{{
              resourceTypesPre[warning.type] +
              resourceTypes[warning.type] +
              resourceTypesUnit[warning.type]
            }}{{ $t('lang.k_132050') }}
          </div>
        </div>
      </div>
      <div class="formItem">
        <div class="label">{{ $t('lang.k_132051') }}</div>
        <div class="vals">
          <div class="timePicker">
            <span class="text">{{ $t('lang.k_132052') }}</span>
            <vh-time-picker
              v-model="warning.date"
              :range-separator="$t('lang.k_132011')"
              :start-placeholder="$t('lang.k_132053')"
              :end-placeholder="$t('lang.k_132054')"
              :placeholder="$t('lang.k_132055')"
              :disabled="!warning.alertSwitch"
              is-range
              format="HH:mm"
              value-format="HH:mm"
              style="width: 240px"
            ></vh-time-picker>
          </div>
        </div>
      </div>
      <div class="formItem">
        <div class="label">{{ $t('lang.k_132056') }}</div>
        <div class="vals swtich">
          <vh-switch
            class="swtich"
            v-model="warning.repeatSwitch"
            active-color="#FB3A32"
            inactive-color="#CECECE"
            :disabled="!warning.alertSwitch"
            :active-text="repeatSwitchDesc"
          ></vh-switch>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <vh-button size="medium" type="info" plain round @click="earlyWarningVisible = false">
          {{ $t('lang.k_132057') }}
        </vh-button>
        <vh-button size="medium" type="primary" round @click="saveWarning">
          {{ $t('lang.k_132058') }}
        </vh-button>
      </div>
    </vh-dialog>
  </div>
</template>

<script>
  import versionInfo from '@/components/DataUsage/index';
  import lintCharts from '@/components/Echarts/lineEcharts';
  import { sessionOrLocal } from '@/utils/utils';
  import { formatMoney } from '@/utils/filter';
  import noData from '@/views/PlatformModule/Error/nullPage';
  import regRule from '@/utils/reg-rule';
  import { throttle } from 'lodash';
  export default {
    name: 'financeInfo',
    components: {
      versionInfo,
      lintCharts,
      noData
    },
    data() {
      return {
        lintData: [],
        buttonList: [],
        type: false,
        lineType: 1,
        accountType: 1,
        versionList: [
          {
            label: this.$t('lang.k_132059'),
            value: 1
          },
          {
            label: this.$t('lang.k_132060'),
            value: 2
          }
        ],
        subject: '',
        lineSearchDate: '',
        accountSearchDate: '',
        trendTypeOptions: [
          {
            label: this.$t('lang.k_132061'),
            value: 'other'
          },
          {
            label: this.$t('lang.k_132062'),
            value: 'sms'
          }
        ],
        trendData: {
          webinar_num: 0,
          total_flow: 0,
          live_flow: 0,
          vod_flow: 0,
          total_duration: 0,
          live_duration: 0,
          vod_duration: 0
        },
        time: '',
        versionType: '',
        trendType: 'other', // 默认查询套餐情况，兼容知学云不要短信功能
        lineParams: {},
        dataParams: {},
        totalNum: 0,
        cmsTotalNum: 0,
        vm: {},
        status: 0,
        tableList: [],
        tableCmsList: [],
        tableColumn: [], // 消费表格
        tableCmsColumn: [], // 消息表格
        smsInfo: null, // 消息对象
        pickerOptions: {
          // disabledDate是一个函数,参数是当前选中的日期值,这个函数需要返回一个Boolean值,
          disabledDate: time => {
            return this.dealDisabledData(time);
          }
        },
        pickerOptionsTwo: {
          // disabledDate是一个函数,参数是当前选中的日期值,这个函数需要返回一个Boolean值,
          disabledDate: time => {
            return this.dealDisabledDataTwo(time);
          }
        },
        earlyWarningVisible: false,
        warning: {
          type: 0,
          value: '',
          phone: '',
          email: '',
          date: null,
          // count: '',
          alertSwitch: false,
          repeatSwitch: false
        },
        resourceTypesPre: [
          this.$t('lang.k_132063'),
          this.$t('lang.k_132064'),
          this.$t('lang.k_132064')
        ],
        resourceTypes: [
          this.$t('lang.k_132065'),
          this.$t('lang.k_132066'),
          this.$t('lang.k_132067')
        ],
        resourceTypesUnit: [
          this.$t('lang.k_132068'),
          this.$t('lang.k_132069'),
          this.$t('lang.k_132069')
        ],
        resourceTypesItem: ['', 'G', this.$t('lang.k_132070')],
        childPremission: {},
        canLoad: false
      };
    },
    computed: {
      showSmsModule: function () {
        const userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
        const isNoticeMessage = JSON.parse(sessionOrLocal.get('SAAS_VS_PES', 'localStorage'))[
          'message_notice'
        ];

        // 不是知学云账号 & 开启了 短信通知配置项权限
        return userInfo.user_extends.extends_remark != 1 && isNoticeMessage == 1;
      },
      alertSwitchDesc() {
        return this.warning.alertSwitch ? this.$t('lang.k_132071') : this.$t('lang.k_132072');
      },
      repeatSwitchDesc() {
        return this.warning.repeatSwitch ? this.$t('lang.k_132073') : this.$t('lang.k_132074');
      }
    },
    filters: {
      formatMoney
    },
    async created() {
      const userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
      // 子账号
      if (userInfo.parent_id > 0) {
        const res = await this.$fetch('getChildPermission');
        if (res.code == 200) {
          console.log('当前权限', res.data);
          sessionOrLocal.set('SAAS_V3_SON_PS', JSON.stringify(res.data));
          this.childPremission = res.data;
        } else {
          sessionOrLocal.removeItem('SAAS_V3_SON_PS');
          this.childPremission = {};
        }

        // 获取子账号权限，更新
        // const childPremission = JSON.parse(sessionOrLocal.get('SAAS_V3_SON_PS'));
        const permission_fin = !(
          this.childPremission && Number(this.childPremission.permission_fin) === 0
        );
        if (!permission_fin) {
          //无权限
          this.$router.push('/warning/404');
          return;
        }
        this.canLoad = true;
      }
      this.canLoad = true;
      this.parentId = JSON.parse(sessionOrLocal.get('userInfo')).parent_id;
      this.childNum = JSON.parse(sessionOrLocal.get('SAAS_VS_PES', 'localStorage'))[
        'child_num_limit'
      ];
      this.userId = JSON.parse(sessionOrLocal.get('userId'));
      this.getVersion();
      if (this.parentId == 0 && this.childNum == 1) {
        this.type = true;
      }
    },
    mounted() {
      this.initPage();
    },
    beforeRouteLeave(to, from, next) {
      if (this.status && this.versionType != 2) {
        this.vm.close();
      }
      next();
    },
    watch: {
      'warning.value'(val) {
        this.warning.value = (val + '').match(regRule.num8)
          ? (val + '').match(regRule.num8)[0]
          : '';
      },
      'warning.phone'(val) {
        this.warning.phone = (val + '').match(regRule.num8)
          ? (val + '').match(regRule.num8)[0]
          : '';
      }
      // 'warning.count'(val) {
      //   this.warning.count = (val + '').match(regRule.num8)
      //     ? (val + '').match(regRule.num8)[0]
      //     : '';
      // }
    },
    methods: {
      dealDisabledData(time) {
        return time.getTime() > Date.now() - 8.64e7; //设置选择今天之前的日期（不能选择当天）
      },
      dealDisabledDataTwo(time) {
        return time.getTime() > Date.now(); //设置选择今天以及今天以前的日期
      },
      initPage() {
        // 初始化设置日期为最近一周
        const end = new Date();
        const start = new Date();
        end.setTime(end.getTime() - 3600 * 1000 * 24);
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.lineSearchDate = [dayjs(start).format('YYYY-MM-DD'), dayjs(end).format('YYYY-MM-DD')];
        this.accountSearchDate = [
          dayjs(start).format('YYYY-MM-DD'),
          dayjs(end).format('YYYY-MM-DD')
        ];
      },
      getVersion() {
        this.$fetch('getVersionInfo', { user_id: this.userId })
          .then(res => {
            this.versionType = parseInt(res.data.type);
            if (res.data.type == 2) {
              this.buttonList = res.data.duration.buttons;
            } else {
              this.buttonList = res.data.concurrency
                ? res.data.concurrency.buttons
                : res.data.flow.buttons;
            }
            this.getLineList();
            this.getAccountList();
            // 格式化表格
            this.compareTableColumns();
            this.status = res.data.arrears.total_fee;
            if (this.status) {
              this.initPayMessage(res.data.arrears);
            }
          })
          .catch(e => {
            console.log(e);
          });
      },
      compareTableColumns() {
        const defaultColumns = [
          {
            label: this.$t('lang.k_132075'),
            key: 'pay_date',
            width: 130
          },
          {
            label: this.$t('lang.k_132076'),
            key: 'webinar_id',
            width: 120
          },
          {
            label: this.$t('lang.k_132077'),
            key: 'subject'
          },
          {
            label: this.$t('lang.k_132078'),
            key: 'typePay',
            width: 120
          },
          {
            label: this.$t('lang.k_132079'),
            key: 'typeText',
            width: 120
          },
          {
            label: this.$t('lang.k_132080'),
            key: 'user_id',
            width: 120
          },
          {
            label: this.$t('lang.k_132081'),
            key: 'nick_name',
            width: 120
          }
        ];

        if (this.trendType == 'sms') {
          defaultColumns.push({
            label: this.$t('lang.k_132082'),
            key: 'sms',
            width: 150
          });
          this.tableCmsColumn = defaultColumns;
        } else {
          this.getColumns(defaultColumns, this.versionType);
        }
      },
      getColumns(defaultColumns, versionType) {
        if (versionType == 1) {
          this.tableColumn = defaultColumns.concat({
            label: this.$t('lang.k_132083'),
            key: 'webinar_flow',
            width: 150
          });
        } else if (versionType == 2) {
          this.tableColumn = defaultColumns.concat({
            label: this.$t('lang.k_132084'),
            key: 'webinar_duration',
            width: 150
          });
        } else {
          this.tableColumn = defaultColumns.concat({
            label: this.$t('lang.k_132025'),
            key: 'webinar_max_uv',
            width: 150
          });
        }
      },
      getSearchLineList() {
        this.$vhall_paas_port({
          k: this.lineType == 1 ? 100697 : 100698,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.getLineList();
      },
      // 用量统计数据
      getLineList() {
        let paramsObj = {
          type: this.lineType || 1
        };
        if (this.lineSearchDate) {
          paramsObj['start_time'] = this.lineSearchDate[0];
          paramsObj['end_time'] = this.lineSearchDate[1];
        }
        let obj = Object.assign({}, paramsObj);
        this.lineParams = obj;
        this.getFlowTrend(obj);
      },
      getFlowTrend(obj) {
        let url =
          this.versionType == 1
            ? 'getFlowLineInfo'
            : this.versionType == '2'
            ? 'getTimeLineInfo'
            : 'getTrendLineInfo';
        this.$fetch(url, obj)
          .then(res => {
            this.lintData = res.data.list;
          })
          .catch(e => {
            console.log(e);
          });
      },
      // 获取并发-最高  流量-活动个数
      getOnlinePay(obj) {
        let url =
          this.versionType == 1
            ? 'getFlowPayInfo'
            : this.versionType == '2'
            ? 'getDurationInfo'
            : 'getTrendHighInfo';
        this.$fetch(url, obj)
          .then(res => {
            this.trendData = res.data || {};
          })
          .catch(e => {
            console.log(e);
          });
      },
      getTypeList() {
        this.$vhall_paas_port({
          k: this.accountType == 1 ? 100700 : 100701,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.getAccountList('search');
      },
      getSearchList() {
        if (this.subject) {
          this.$vhall_paas_port({
            k: 100699,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: '',
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
        this.getAccountList('search');
      },
      // 订单明细
      goAccountDetail() {
        this.$vhall_paas_port({
          k: 100695,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.$router.push({
          path: '/plan/infoDetail'
        });
      },
      // 获取消费账单列表
      getAccountList(params) {
        let pageInfo = this.$refs.accountTableList.pageInfo;
        let paramsObj = {
          subject: this.subject,
          type: this.accountType || 1
        };
        if (params == 'search') {
          pageInfo.pos = 0;
          pageInfo.pageNum = 1;
        }
        if (this.accountSearchDate) {
          paramsObj['start_time'] = this.accountSearchDate[0];
          paramsObj['end_time'] = this.accountSearchDate[1];
        } else {
          paramsObj['start_time'] = '';
          paramsObj['end_time'] = '';
        }
        this.dataParams = this.$params(paramsObj);
        let obj = Object.assign({}, pageInfo, paramsObj);

        this.getOnlinePay(this.$params(this.dataParams));
        this.getUserSmsPay(this.$params(this.dataParams));
        // 格式化表格头
        this.compareTableColumns();
        this.$nextTick(() => {
          if (this.trendType == 'sms') {
            // 获取短信消耗明细
            this.getUserSmsPayByPage(this.$params(obj));
          } else {
            // 获取流量消耗明细
            this.getDataList(this.$params(obj));
          }
        });
      },
      // 流量消费等查询
      getDataList(obj) {
        let url =
          this.versionType == 1
            ? 'getBusinessList'
            : this.versionType == 2
            ? 'getDurationList'
            : 'getAccountList';
        this.$fetch(url, obj)
          .then(res => {
            let costList = res.data.list;
            this.totalNum = res.data.total;
            costList.map(item => {
              item.typeText = item.type == 1 ? this.$t('lang.k_132059') : this.$t('lang.k_132085');
              item.typePay =
                item.pay_type >= 0 && item.pay_type <= 4
                  ? [
                      '',
                      this.$t('lang.k_132065'),
                      this.$t('lang.k_132066'),
                      this.$t('lang.k_132067'),
                      this.$t('lang.k_132086')
                    ][item.pay_type]
                  : '';
            });
            this.tableList = costList;
          })
          .catch(e => {
            console.log(e);
          });
      },
      // 短信消耗总数查询
      getUserSmsPay(obj) {
        this.$fetch('getUserSmsPay', obj)
          .then(res => {
            this.smsInfo = res.data;
          })
          .catch(e => {
            console.log(e);
          });
      },
      // 短信分页查询
      getUserSmsPayByPage(obj) {
        this.$fetch('getUserSmsPayByPage', obj)
          .then(res => {
            let costList = res.data.list;
            this.cmsTotalNum = res.data.total;
            costList.map(item => {
              item.typeText = item.type == 1 ? this.$t('lang.k_132059') : this.$t('lang.k_132085');
              item.typePay =
                item.pay_type >= 0 && item.pay_type <= 4
                  ? [
                      '',
                      this.$t('lang.k_132065'),
                      this.$t('lang.k_132066'),
                      this.$t('lang.k_132067'),
                      this.$t('lang.k_132086')
                    ][item.pay_type]
                  : '';
            });
            this.tableCmsList = costList;
          })
          .catch(e => {
            console.log(e);
          });
      },
      getOrderArrear() {
        let params = {
          user_id: this.userId,
          type: this.versionType == 1 ? 1 : 2
        };
        this.$fetch('orderArrears', params)
          .then(res => {
            if (res.code == 200) {
              this.$router.push({
                path: '/plan/payOrder',
                query: {
                  userId: this.userId,
                  orderId: res.data.order_id
                }
              });
            }
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || this.$t('lang.k_132087'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
            console.log(res);
          });
      },
      initPayMessage(info) {
        if (this.versionType == 2) {
          this.$vhMessage({
            showClose: true,
            duration: 0,
            dangerouslyUseHTMLString: true,
            message: this.$t('lang.k_132088'),
            type: 'warning'
          });
          return;
        }
        let that = this;
        let flow = info.flow;
        let extendFee = info.extend;
        let total = flow < 0 ? `${flow} G` : this.$t('lang.k_132089', [extendFee]);
        let text = this.$t('lang.k_132090', [
          this.versionType == 1 ? this.$t('lang.k_132066') : this.$t('lang.k_132065'),
          info.total_fee,
          total
        ]);
        this.vm = this.$vhMessage({
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message:
            '<p style="color:#1A1A1A">' +
            text +
            '<span id="openList" style="color:#FA9A32;cursor: pointer;padding-left:10px">' +
            this.$t('lang.k_132091') +
            '</span></p>',
          type: 'warning'
        });
        let open = document.querySelector('#openList');
        open.addEventListener('click', function (e) {
          that.vm.close();
          that.getOrderArrear();
        });
      },
      // 导出用量统计
      exportCenterData: throttle(
        function () {
          let url =
            this.versionType == 1
              ? 'exportFlow'
              : this.versionType == 2
              ? 'exportDuration'
              : 'exportOnline';
          this.$fetch(url, this.lineParams)
            .then(res => {
              this.$vhall_paas_port({
                k: 100696,
                data: {
                  business_uid: this.userId,
                  user_id: '',
                  webinar_id: '',
                  refer: '',
                  s: '',
                  report_extra: {},
                  ref_url: '',
                  req_url: ''
                }
              });
              this.$vhMessage({
                message: this.$t('lang.k_132092', [
                  this.versionType == 1
                    ? this.$t('lang.k_132066')
                    : this.versionType == 2
                    ? this.$t('lang.k_132067')
                    : this.$t('lang.k_132065'),

                  this.$store.state.permissionValue.custom_download_toast ||
                    this.$t('lang.k_132093')
                ]),

                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
              this.$EventBus.$emit('saas_vs_download_change');
            })
            .catch(res => {
              this.$vhMessage({
                message:
                  res.msg ||
                  this.$t('lang.k_132094', [
                    this.versionType == 1
                      ? this.$t('lang.k_132066')
                      : this.versionType == 2
                      ? this.$t('lang.k_132067')
                      : this.$t('lang.k_132065')
                  ]),

                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            });
        },
        2000,
        {
          trailing: false
        }
      ),
      // 导出消费账单
      exportAccount() {
        let url = '';
        if (this.trendType == 'sms') {
          // 短信导出
          url = 'exportUserSmsPayDetail';
        } else {
          url =
            this.versionType == 1
              ? 'exportFlowDetail'
              : this.versionType == 2
              ? 'exportDurationDetail'
              : 'exportOnlineDetail';
        }
        this.$fetch(url, this.dataParams)
          .then(res => {
            this.$vhall_paas_port({
              k: 100702,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            this.$vhMessage({
              message: this.$t('lang.k_132095', [
                this.trendType == 'sms'
                  ? this.$t('lang.k_132086')
                  : this.versionType == 1
                  ? this.$t('lang.k_132066')
                  : this.versionType == 2
                  ? this.$t('lang.k_132067')
                  : this.$t('lang.k_132065'),

                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_132093')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          })
          .catch(res => {
            this.$vhMessage({
              message:
                res.msg ||
                this.$t('lang.k_132096', [
                  this.trendType == 'sms'
                    ? this.$t('lang.k_132086')
                    : this.versionType == 1
                    ? this.$t('lang.k_132066')
                    : this.versionType == 2
                    ? this.$t('lang.k_132067')
                    : this.$t('lang.k_132065')
                ]),

              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      //预警提醒
      openEarlyWarning() {
        this.getWarning().then(res => {
          console.log(res);
          if (res) {
            this.earlyWarningVisible = true;
          } else {
            this.earlyWarningVisible = false;
          }
        });
      },
      //保存预警设置
      saveWarning() {
        console.log(this.warning);
        let params = {};
        if (this.warning.alertSwitch) {
          if (!this.warning.value) {
            this.$vhMessage.warning(this.$t('lang.k_132097'));
            return;
          }
          if (!this.warning.phone && !this.warning.email) {
            this.$vhMessage.warning(this.$t('lang.k_132098'));
            return;
          }
          if (this.warning.phone && !regRule.mobile.test(this.warning.phone)) {
            this.$vhMessage.warning(this.$t('lang.k_132099'));
            return;
          }
          if (this.warning.email && !regRule.email.test(this.warning.email)) {
            this.$vhMessage.warning(this.$t('lang.k_132100'));
            return;
          }
          if (!this.warning.date || this.warning.date[0] == '' || this.warning.date[1] == '') {
            this.$vhMessage.warning(this.$t('lang.k_132101'));
            return;
          }
          params = {
            nums: this.warning.value,
            receive_phone: this.warning.phone,
            receive_email: this.warning.email,
            begin_time: this.warning.date[0],
            end_time: this.warning.date[1],
            warning_switch: 1,
            repeat_notice: this.warning.repeatSwitch ? 1 : 0
          };
          if (!this.warning.phone) {
            delete params.receive_phone;
          }
          if (!this.warning.email) {
            delete params.receive_email;
          }
          this.$fetch('saveWarningInfo', params)
            .then(res => {
              if (res.code == 200) {
                this.earlyWarningVisible = false;
              }
            })
            .catch(res => {
              this.$vhMessage({
                message: res.msg || this.$t('lang.k_132102'),
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            });
        } else {
          params = {
            warning_switch: 0
          };
          this.$fetch('setWarningSwitch', params)
            .then(res => {
              if (res.code == 200) {
                this.earlyWarningVisible = false;
              }
            })
            .catch(res => {
              this.$vhMessage({
                message: res.msg || this.$t('lang.k_132102'),
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            });
        }
      },
      //获取预警设置
      getWarning() {
        return this.$fetch('getWarningInfo')
          .then(res => {
            if (res.code == 200) {
              this.warning.type = res.data.resource_type; //0并发 1流量 2时长
              this.warning.value = res.data.nums; //
              this.warning.phone = res.data.receive_phone; //
              this.warning.email = res.data.receive_email; //
              this.warning.date =
                res.data.begin_time || res.data.end_time
                  ? [res.data.begin_time, res.data.end_time]
                  : null; //
              this.warning.alertSwitch = res.data.warning_switch == 1; //提醒开关：0关闭 1开启
              this.warning.repeatSwitch = res.data.repeat_notice == 1; //是否重复发送：0否   1是 - 最多发送10次
              this.$nextTick(0);
              return true;
            }
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || this.$t('lang.k_132087'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
            return false;
          });
      }
    }
  };
</script>

<style lang="less" scoped>
  .finance-info {
    .serach-line {
      padding: 24px;
      border-radius: 4px;
      background: #fff;
    }
    .title-data {
      margin: 0 0 20px 0;
      text-align: left;
      line-height: 30px;
      position: relative;
      span {
        font-size: 22px;

        font-weight: 600;
        color: #1a1a1a;
      }
      .detail {
        position: absolute;
        top: 0;
        right: 0;
        color: #262626;
        font-size: 14px;
        cursor: pointer;
        &:last-child {
          right: 80px;
          padding-right: 10px;
          color: #3b67f9;
        }
      }
    }
    .statistical-line {
      text-align: left;
      position: relative;
      margin-top: 20px;
      span {
        display: inline-block;
        font-size: 16px;
        color: #1a1a1a;
        margin-bottom: 10px;
        padding-bottom: 5px;
      }
      i {
        font-size: 14px;
        padding: 0 2px;
      }
    }
    .content-grid {
      width: 100%;
      height: 100px;
      margin-bottom: 20px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .content-item {
        width: 24%;
        background: #f7f7f7;
        height: 100px;
        border-radius: 4px;
      }
      .grid-item {
        width: 49%;
        background: #f7f7f7;
        height: 100px;
        border-radius: 4px;
      }
      &.include_sms {
        .content-item {
          width: 19%;
        }
        .grid-item {
          width: 33%;
        }
      }
      .grid-content {
        margin: 24px 16px;
        text-align: left;
        h1 {
          font-size: 28px;
          color: #1a1a1a;
          line-height: 32px;
          font-weight: bold;
        }
        p {
          font-size: 14px;
          color: #999;
          line-height: 20px;
          display: inline;
          i {
            color: #1a1a1a;
          }
        }
      }
    }
    .search-data {
      position: relative;
      padding: 5px 0 20px 0;
      // margin-bottom: 15px;
      &/deep/ .vh-select,
      & > .search-tag {
        margin-left: 12px;
      }
      .export-data {
        position: absolute;
        right: 0;
        top: 7px;
      }
    }
  }
  ::v-deep .saasicon_help_m {
    color: #999999;
  }
</style>
<style lang="less">
  .earlyWarningSet {
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #262626;
    }
    .formItem {
      display: flex;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        font-size: 14px;
        font-weight: 400;
        color: #262626;
        min-width: 56px;
        margin-right: 12px;
        line-height: 1.6;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
      }
      .vals {
        .vh-input-group__append,
        .vh-input-group__prepend {
          padding: 0 10px;
        }
        &.swtich {
          display: flex;
          align-items: center;
        }
        .inputs {
          display: flex;
          align-items: center;
          .setInput {
            width: 180px;
            margin-right: 10px;
          }
        }
        .tip {
          margin-top: 10px;
        }
        .timePicker {
          // margin-bottom: 10px;
        }
        .text {
          margin-right: 10px;
        }
        .count {
          .setInput {
            width: 120px;
          }
        }
      }
    }
  }
</style>
